import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/v1/`,
});

// Loader callbacks
let loaderCallbacks = {
  showLoader: null,
  hideLoader: null,
};

export const setLoaderCallbacks = (showLoader, hideLoader) => {
  loaderCallbacks.showLoader = showLoader;
  loaderCallbacks.hideLoader = hideLoader;
};

/* REQUEST */
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (!config.headers["X-SILENT"]) {
      loaderCallbacks.showLoader?.();
    }

    return config;
  },
  (error) => {
    loaderCallbacks.hideLoader?.();
    return Promise.reject(error);
  }
);

/* RESPONSE */
API.interceptors.response.use(
  (response) => {
    if (!response.config.headers["X-SILENT"]) {
      loaderCallbacks.hideLoader?.();
    }
    return response;
  },
  (error) => {
    if (!error.config?.headers["X-SILENT"]) {
      loaderCallbacks.hideLoader?.();
    }

    if (error.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default API;